(() => {
  if (!document.body.classList.contains('template-index')) return;
  if (window.LPLHomepageHybrid) return;
  window.LPLHomepageHybrid = true;
  const body = document.body;
  // A single hidden probe keeps the canonical .page-width gutter without adding
  // and removing a node (and invalidating layout) on every header resize.
  const rail = document.createElement('div');
  rail.className = 'page-width';
  rail.hidden = true;
  rail.setAttribute('aria-hidden', 'true');
  rail.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none';
  body.append(rail);
  let headers = [];
  let previewBar = null;
  let measureFrame = 0;
  const setProperty = (name, value) => {
    if (body.style.getPropertyValue(name) !== value) body.style.setProperty(name, value);
  };
  const measure = () => {
    measureFrame = 0;
    // Finish every geometry/style read before changing inherited CSS variables.
    const headerHeight = headers.reduce((height, element) => height + element.getBoundingClientRect().height, 0);
    const previewHeight = previewBar?.isConnected ? previewBar.getBoundingClientRect().height : 0;
    const gutter = matchMedia('(max-width:749px)').matches ? '24px' : getComputedStyle(rail).paddingLeft;
    setProperty('--lpl-header-h', `${Math.round(headerHeight)}px`);
    setProperty('--lpl-preview-h', `${Math.round(previewHeight)}px`);
    setProperty('--lpl-gutter', gutter);
  };
  const scheduleMeasure = () => {
    if (!measureFrame) measureFrame = requestAnimationFrame(measure);
  };
  const headerObserver = new ResizeObserver(scheduleMeasure);
  const observeLayout = () => {
    headerObserver.disconnect();
    headers = [...document.querySelectorAll('.shopify-section-group-header-group')];
    headers.forEach(element => headerObserver.observe(element));
    // Shopify's draft toolbar occupies the bottom of the viewport, above slide controls.
    previewBar = document.getElementById('PBarNextFrameWrapper');
    if (previewBar) headerObserver.observe(previewBar);
    scheduleMeasure();
  };
  observeLayout();
  window.addEventListener('resize', scheduleMeasure, { passive: true });
  new MutationObserver(() => {
    if (document.getElementById('PBarNextFrameWrapper') !== previewBar) observeLayout();
  }).observe(body, { childList: true });

  function setupHero(hero) {
    if (hero.dataset.lplReady) return;
    hero.dataset.lplReady = 'true';
    window.LPLSwiper.section(hero.dataset.lplHomeHero, (Swiper, scope, lifecycle) => {
      const slider = hero.querySelector('.bs__slider--wrapp');
      const ticks = [...hero.querySelectorAll('.lplh__tick')];
      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        autoHeight: true,
        breakpoints: { 750: { autoHeight: false } },
        rewind: true,
        speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450,
        a11y: { enabled: true },
      });
      const sync = () => {
        ticks.forEach((tick, index) => tick.setAttribute('aria-pressed', String(index === swiper.activeIndex)));
        [...slider.querySelectorAll('.swiper-slide')].forEach((slide, index) => {
          slide.inert = index !== swiper.activeIndex;
        });
      };
      ticks.forEach((tick, index) => lifecycle.listen(tick, 'click', () => swiper.slideTo(index)));
      const next = hero.querySelector('.lplh__next');
      if (next) lifecycle.listen(next, 'click', () => swiper.slideNext());
      swiper.on('slideChange', sync);
      // The mobile panel follows each slide's copy length, including after fonts load.
      const refreshHeight = () => {
        if (!swiper.destroyed && swiper.params.autoHeight) swiper.updateAutoHeight(0);
      };
      lifecycle.listen(window, 'load', refreshHeight);
      if (document.fonts) document.fonts.ready.then(refreshHeight);
      // Deferred section CSS and font swaps can change the stacked copy height.
      // Observe only hero copy boxes and coalesce updates before touching Swiper.
      let heightFrame = 0;
      const heightObserver = new ResizeObserver(() => {
        if (!heightFrame && swiper.params.autoHeight) heightFrame = requestAnimationFrame(() => {
          heightFrame = 0;
          refreshHeight();
        });
      });
      hero.querySelectorAll('.bs__content-wrapp').forEach(copy => heightObserver.observe(copy));
      lifecycle.cleanup(() => {
        heightObserver.disconnect();
        if (heightFrame) cancelAnimationFrame(heightFrame);
        slider.querySelectorAll('.swiper-slide').forEach(slide => { slide.inert = false; });
        delete hero.dataset.lplReady;
      });
      sync();
    });
  }
  document.querySelectorAll('[data-lpl-home-hero]').forEach(setupHero);
  document.addEventListener('shopify:section:unload', observeLayout);
  document.addEventListener('shopify:section:load', event => {
    observeLayout();
    event.target.querySelectorAll('[data-lpl-home-hero]').forEach(setupHero);
  });
})();
